import React, { useMemo } from "react";
import DOMPurify from "dompurify";
import "./richtext.css";

// Allow iframes (YouTube embeds) through the sanitizer.
const CONFIG = {
  ADD_TAGS: ["iframe"],
  ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling", "target", "colspan", "rowspan", "colwidth", "style", "data-youtube-video"],
};

export const RichTextContent = ({ html, className = "", testid }) => {
  const clean = useMemo(() => DOMPurify.sanitize(html || "", CONFIG), [html]);
  return (
    <div
      data-testid={testid}
      className={`rt-content ${className}`}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
};
